/** Numeric presets for Type panel font size chips. */
export const FONT_SIZE_PRESETS = [8, 12, 18, 32, 72] as const

/** Practical font-size bounds for the slider / numeric input (points). */
export const FONT_SIZE_MIN = 6
export const FONT_SIZE_MAX = 1200

/** Stored in the proto run when the user selects font-metric-driven leading (~1.2× font size). */
export const LEADING_METRIC_SENTINEL = 'Metric'

/** Valid leading input range in pt. The slider covers this same range — see the Leading slider
 *  (`components/spacing-section.tsx`), which uses `LEADING_MAX` directly rather than a separate,
 *  narrower cap. */
export const LEADING_MIN = 0
export const LEADING_MAX = 500

/**
 * Kerning preset values in 1/1000 em units (print industry convention).
 * Narrow = -10 (tight), Natural = 0 (no adjustment), Wide = 25 (loose).
 */
export const KERNING_PRESET_VALUES = [-10, 0, 25] as const

/** Valid kerning input range in 1/1000 em. */
export const KERNING_MIN = -100
export const KERNING_MAX = 200

/**
 * Tracking preset values in 1/1000 em units (print industry convention).
 * Narrow = -25 (tight), Natural = 0 (no adjustment), Wide = 50 (loose).
 */
export const TRACKING_PRESET_VALUES = [-25, 0, 50] as const

/** Valid tracking input range in 1/1000 em. */
export const TRACKING_MIN = -100
export const TRACKING_MAX = 200

/** Chip labels for the Kerning and Tracking presets, index-aligned with `KERNING_PRESET_VALUES`
 *  and `TRACKING_PRESET_VALUES`. */
export const SPACING_PRESET_LABELS = ['Narrow', 'Natural', 'Wide'] as const
